import {ChangeDetectorRef, Component, Input, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import {ThingRainSensorInterface} from '@app/app/shared/interfaces/thing/thing-rain-sensor.interface';
import {CommandsService} from '@app/app/shared/services/commands.service';

@Component({
  templateUrl: './park-rain-sensor-item.html',
  selector: 'park-rain-sensor-item'
})

export class ParkRainSensorItemComponent implements OnDestroy {
  @Input() public rainSensor: ThingRainSensorInterface;
  @Input() public rainSensorId: any;
  @Input() public parkId: any;
  @Input() public id: any;

  public isRunningAuto = false;
  public isRunningBypass = false;

  private timerSub: Subscription;

  private MODE_AUTO = 'auto';
  private MODE_BYPASS = 'bypass';

  constructor(private comm: CommandsService, private cdRef: ChangeDetectorRef) {
    //
  }

  /**
   * Set mode to auto
   */
  public setModeAuto() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningAuto = true;
      this.update(this.MODE_AUTO);
    }
  }

  /**
   * Set mode to manual
   */
  public setModeBypass() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningBypass = true;
      this.update(this.MODE_BYPASS);
    }
  }

  public isAuto() {
    const isAuto = (this.rainSensor.md === this.MODE_AUTO);

    if (isAuto && this.isRunningAuto) {
      this.isRunningAuto = false;
      this.cdRef.detectChanges();
    }

    return isAuto;
  }

  public isBypass() {
    const isTank = (this.rainSensor.md === this.MODE_BYPASS);

    if (isTank && this.isRunningBypass) {
      this.isRunningBypass = false;
      this.cdRef.detectChanges();
    }

    return isTank;
  }

  public isRunning() {
    return (this.isRunningAuto || this.isRunningBypass);
  }

  /**
   * Update activator
   */
  private update(mode: string) {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    this.comm.setRainSensorMode(this.parkId, this.id, this.rainSensorId, mode).then((res) => {
      this.timerSub = Observable.of(true).delay(15000).subscribe(() => {
        if (this.isRunningAuto && !this.isAuto()) {
          alert('Timed Out');
        }

        if (this.isRunningBypass && !this.isBypass()) {
          alert('Timed Out');
        }

        this.isRunningAuto = false;
        this.isRunningBypass = false;
      });
    }).catch((err) => {
      this.isRunningAuto = false;
      this.isRunningBypass = false;

      alert(err);
    });
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/others/rain_sensor/rain-sensor-item/park-rain-sensor-item.component.ts